import { inject, Injectable } from '@angular/core'
import { UserAccount } from '../../../api/models/user-account.model'
import { AccountService } from '../../../api/services/accounts.service'

@Injectable({ providedIn: 'root' })
export class AuthService {
    accountService: AccountService = inject(AccountService)

    async fetchAccount(): Promise<UserAccount | undefined> {
        try {
            return this.accountService.getAccount()
        } catch (err) {
            return undefined
        }
    }

    isAuthorizedForWithAccount(account: UserAccount | undefined, allowedRoles: Array<string>): boolean {
        if (!account?.identityRoles?.length || !allowedRoles?.length) {
            return false
        }

        return account.identityRoles.some((role) => allowedRoles.includes(role))
    }
}
